export default __webpack_public_path__ + "static/media/05_dimond 2.2cb7786c.svg";